import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 用户列表
export const setUserPages: Mutation<IModuleState> = (state, payload) => {
  state.userPage.data = payload.data;
  state.userPage.total = payload.total;
  state.userPage.pageNum = payload.pageNum;
  state.userPage.pageSize = payload.pageSize;
  state.userPage.loading = !!payload.loading;
};

// 当前登录用户所在组织拥有的角色列表
export const setMineRoles: Mutation<IModuleState> = (state, payload) => {
  state.mineRoles.data = payload.data;
  state.mineRoles.loading = !!payload.loading;
};

// 组织已拥有的角色列表
export const setOrgRoles: Mutation<IModuleState> = (state, payload) => {
  state.orgRoles.data = payload.data;
  state.orgRoles.loading = !!payload.loading;
};

// 用户已拥有的角色列表
export const setUserRoles: Mutation<IModuleState> = (state, payload) => {
  state.userRoles.data = payload.data;
  state.userRoles.loading = !!payload.loading;
};

// 组织的授权品牌列表
export const setOrgBrandList: Mutation<IModuleState> = (state, payload) => {
  state.orgBrandList.data = payload.data;
  state.orgBrandList.loading = !!payload.loading;
};

// 用户的授权品牌列表
export const setUserBrandList: Mutation<IModuleState> = (state, payload) => {
  state.userBrandList.data = payload.data;
  state.userBrandList.loading = !!payload.loading;
};

// 用户密钥
export const setKeyPair: Mutation<IModuleState> = (state, payload) => {
  state.keypair.data = payload.data;
  state.keypair.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.type = payload.type;
  state.confirm.data = payload.data;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 列表搜索条件
export const setSearch: Mutation<IModuleState> = (state, payload) => {
  state.search = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
